var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    { ref: "unitary_form" },
    [
      _c(
        "v-layout",
        { attrs: { row: "", "justify-center": "" } },
        [
          _c(
            "v-flex",
            [
              _c(
                "v-card",
                { attrs: { color: "background darken-1 elevation-0" } },
                [
                  _c(
                    "v-card-text",
                    { staticClass: "pa-0" },
                    [
                      _c(
                        "v-stepper",
                        {
                          staticClass: "background darken-1 elevation-0",
                          attrs: { vertical: "" },
                          model: {
                            value: _vm.step,
                            callback: function($$v) {
                              _vm.step = $$v
                            },
                            expression: "step"
                          }
                        },
                        [
                          _c(
                            "v-stepper-step",
                            {
                              attrs: {
                                editable: _vm.step > 1,
                                complete: _vm.step > 1,
                                step: "1",
                                color: "primary color--text"
                              }
                            },
                            [
                              _c("span", { staticClass: "subheading" }, [
                                _vm._v("Choix du répertoire")
                              ]),
                              _vm._v(" "),
                              _vm.form.parameters.directory
                                ? _c(
                                    "small",
                                    { staticClass: "primary--text" },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: { small: "", color: "primary" }
                                        },
                                        [_vm._v("arrow_forward")]
                                      ),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.form.parameters.directory
                                          ) +
                                          "\n\t\t\t\t\t\t\t"
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-stepper-content",
                            { staticClass: "pt-0", attrs: { step: "1" } },
                            [
                              _c("v-text-field", {
                                staticClass: "grv-input",
                                attrs: {
                                  solo: "",
                                  readonly: "",
                                  rules: [_vm.checkRequired],
                                  name: "Répertoire source",
                                  "append-icon": "folder_open"
                                },
                                on: {
                                  "click:append": function($event) {
                                    _vm.showExplorer = true
                                  }
                                },
                                model: {
                                  value: _vm.form.parameters.directory,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form.parameters,
                                      "directory",
                                      $$v
                                    )
                                  },
                                  expression: "form.parameters.directory"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "text-none ml-0",
                                  attrs: {
                                    color: "primary color--text",
                                    disabled: !_vm.form.parameters.directory
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.step = 2
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\tContinuer\n\t\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-stepper-step",
                            {
                              attrs: {
                                editable: _vm.step > 2,
                                complete: _vm.step > 2,
                                color: "primary color--text",
                                step: "2"
                              }
                            },
                            [
                              _c("span", { staticClass: "subheading" }, [
                                _vm._v("Choix de la référence SUIFA")
                              ]),
                              _vm._v(" "),
                              _vm.form.parameters.suifa_ref
                                ? _c(
                                    "small",
                                    { staticClass: "primary--text" },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: { small: "", color: "primary" }
                                        },
                                        [_vm._v("arrow_forward")]
                                      ),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.form.parameters.suifa_ref
                                          ) +
                                          "\n\t\t\t\t\t\t\t"
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-stepper-content",
                            { staticClass: "pt-0", attrs: { step: "2" } },
                            [
                              _c(
                                "v-text-field",
                                {
                                  staticClass: "grv-input",
                                  attrs: {
                                    solo: "",
                                    rules: [
                                      _vm.checkRequired,
                                      _vm.checkRefSuifa
                                    ],
                                    name: "Référence SUIFA",
                                    loading: _vm.suifaInfos.loading
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.getBehiveAssetInfo(
                                        _vm.form.parameters.suifa_ref
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.form.parameters.suifa_ref,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form.parameters,
                                        "suifa_ref",
                                        $$v
                                      )
                                    },
                                    expression: "form.parameters.suifa_ref"
                                  }
                                },
                                [
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { slot: "append", bottom: "" },
                                      slot: "append"
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            slot: "activator",
                                            icon: "",
                                            small: "",
                                            disabled: !_vm.form.parameters
                                              .suifa_ref,
                                            loading: _vm.suifaInfos.loading
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.getBehiveAssetInfo(
                                                _vm.form.parameters.suifa_ref
                                              )
                                            }
                                          },
                                          slot: "activator"
                                        },
                                        [_c("v-icon", [_vm._v("search")])],
                                        1
                                      ),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\tGet data from Behive/Suifa\n\t\t\t\t\t\t\t\t"
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.errors
                                ? _c(
                                    "div",
                                    _vm._l(_vm.errors, function(error) {
                                      return _c("div", { key: error.id }, [
                                        _c(
                                          "p",
                                          { staticClass: "error--text" },
                                          [_vm._v(_vm._s(error))]
                                        )
                                      ])
                                    }),
                                    0
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.suifaInfos.data
                                ? _c("table", { staticClass: "info-table" }, [
                                    _c("tbody", [
                                      _vm.suifaInfos.data.type_sup
                                        ? _c("tr", [
                                            _c("th", [_vm._v("Asset type")]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.suifaInfos.data.type_sup
                                                    .code_type_sup
                                                )
                                              )
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.suifaInfos.data.titre
                                        ? _c("tr", [
                                            _c("th", [_vm._v("Titre")]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.suifaInfos.data.titre
                                                    .titre_princ
                                                )
                                              )
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.suifaInfos.data.asset_size
                                        ? _c("tr", [
                                            _c("th", [_vm._v("Poids")]),
                                            _vm._v(" "),
                                            _c("td", [
                                              String(
                                                _vm.suifaInfos.data.asset_size
                                              ).length < 10
                                                ? _c(
                                                    "span",
                                                    { staticClass: "mb-1" },
                                                    [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t- " +
                                                          _vm._s(
                                                            _vm.$weight.bitRoundToTwo(
                                                              _vm.suifaInfos
                                                                .data
                                                                .asset_size,
                                                              2
                                                            )
                                                          ) +
                                                          " Mo\n\t\t\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ]
                                                  )
                                                : _c(
                                                    "span",
                                                    { staticClass: "mb-1" },
                                                    [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t- " +
                                                          _vm._s(
                                                            _vm.$weight.bitRoundToTwo(
                                                              _vm.suifaInfos
                                                                .data
                                                                .asset_size,
                                                              3
                                                            )
                                                          ) +
                                                          " Go\n\t\t\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ]
                                                  )
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.suifaInfos.data.t_aux_proprio
                                        ? _c("tr", [
                                            _c("th", [_vm._v("Ayant droit")]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.suifaInfos.data
                                                    .t_aux_proprio.t_libelle
                                                ) +
                                                  " - (" +
                                                  _vm._s(
                                                    _vm.suifaInfos.data
                                                      .t_aux_proprio
                                                      .t_auxiliaire
                                                  ) +
                                                  ")"
                                              )
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("tr", [
                                        _c("th", [_vm._v("Contrat catalogue")]),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          [
                                            _vm.localHasContract
                                              ? _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      color: "green accent-3"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t\t\ttask_alt\n\t\t\t\t\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                )
                                              : _c(
                                                  "v-icon",
                                                  { attrs: { color: "red" } },
                                                  [_vm._v("block")]
                                                )
                                          ],
                                          1
                                        )
                                      ])
                                    ])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "text-none",
                                  attrs: {
                                    color: "primary color--text",
                                    disabled:
                                      _vm.errors.length > 0 ||
                                      !_vm.suifaInfos.data
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.step = 3
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\tContinuer\n\t\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-stepper-step",
                            {
                              attrs: { color: "primary color--text", step: "3" }
                            },
                            [
                              _c("span", { staticClass: "subheading" }, [
                                _vm._v("Confirmation et stockage")
                              ]),
                              _vm._v(" "),
                              _c("small", [
                                _vm._v(
                                  "Veuillez vérifier les informations entrées"
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-stepper-content",
                            { staticClass: "pt-0", attrs: { step: "3" } },
                            [
                              _vm.suifaInfos.data
                                ? _c("table", { staticClass: "info-table" }, [
                                    _c("tbody", [
                                      _c("tr", [
                                        _c("th", [
                                          _vm._v("Répertoire sélectionné")
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.form.parameters.directory
                                            )
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("tr", [
                                        _c("th", [_vm._v("référence SUIFA")]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.form.parameters.suifa_ref
                                            )
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("tr", [
                                        _c("th", [_vm._v("T aux")]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.suifaInfos.data.t_aux_proprio
                                                .t_libelle
                                            )
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("tr", [
                                        _c("th", [_vm._v("Titre")]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.suifaInfos.data.titre
                                                .titre_princ
                                            )
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("tr", [
                                        _c("th", [_vm._v("Type programme")]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.suifaInfos.data.programme
                                                .type_prgm.lib_type_prgm
                                            )
                                          )
                                        ])
                                      ])
                                    ])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.$user.isAdmin()
                                ? _c(
                                    "div",
                                    [
                                      _vm.manifest
                                        ? _c("tree-view", {
                                            attrs: {
                                              data: _vm.manifest,
                                              options: {
                                                rootObjectKey: "manifest"
                                              }
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("br")
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-layout",
                                {
                                  staticClass: "ma-0",
                                  attrs: { row: "", wrap: "" }
                                },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs6: "" } },
                                    [
                                      _c("v-select", {
                                        staticClass: "grv-input",
                                        attrs: {
                                          solo: "",
                                          dense: "",
                                          flat: "",
                                          label: "Type de stockage",
                                          rules: [_vm.checkRequired],
                                          name: "Type de stockage",
                                          "menu-props": {
                                            contentClass: "grv-menu"
                                          },
                                          "prepend-inner-icon": "archive",
                                          items: _vm.storage_list
                                        },
                                        model: {
                                          value:
                                            _vm.form.parameters.server_storage,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form.parameters,
                                              "server_storage",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "form.parameters.server_storage"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs6: "" } },
                                    [
                                      _c("v-checkbox", {
                                        staticClass: "mb-2 pl-2 grv-input",
                                        attrs: {
                                          "hide-details": "",
                                          label: "Supprimer la source",
                                          name: "Supprimer la source",
                                          color: "primary"
                                        },
                                        model: {
                                          value:
                                            _vm.form.parameters.remove_source,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form.parameters,
                                              "remove_source",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "form.parameters.remove_source"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.showExplorer
            ? _c(
                "Explorer",
                {
                  attrs: {
                    shortcuts: _vm.explorer.shortcuts,
                    assetType: _vm.explorer.assetType,
                    multiselect: false
                  },
                  on: {
                    close: function($event) {
                      _vm.showExplorer = false
                    },
                    selectedAssets: function($event) {
                      return _vm.onSelectDir($event)
                    }
                  }
                },
                [
                  _c("h3", { attrs: { slot: "header" }, slot: "header" }, [
                    _vm._v("Asset Select for Maestro ingester")
                  ])
                ]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a98d446", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a98d446","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/pages/maestro/launcher/forms/launcher_form_dvd_bd.vue
// module id = null
// module chunks = 